/**
 * The 47 counties of Kenya, in the order of the First Schedule to the
 * Constitution — which is the order every Kenyan has met on a form before, so
 * a person scanning for Nyandarua looks in the same place they always have.
 *
 * One list, because the alternative is what was here before: a twelve-county
 * array in PropertyForm, free-text boxes on Services and Marketplace, and a
 * third list built from whatever counties happened to have listings. A seller
 * typing "Nrb" and a searcher choosing "Nairobi" then never meet, and nothing
 * in the product can tell you why.
 *
 * Stored as the county NAME rather than a code: it is what the columns already
 * hold on properties, listings, providers and items, and a migration to codes
 * would rewrite four tables to answer a question nobody has asked.
 */
export const KENYA_COUNTIES = [
  'Mombasa', 'Kwale', 'Kilifi', 'Tana River', 'Lamu', 'Taita Taveta',
  'Garissa', 'Wajir', 'Mandera', 'Marsabit', 'Isiolo', 'Meru',
  'Tharaka Nithi', 'Embu', 'Kitui', 'Machakos', 'Makueni', 'Nyandarua',
  'Nyeri', 'Kirinyaga', "Murang'a", 'Kiambu', 'Turkana', 'West Pokot',
  'Samburu', 'Trans Nzoia', 'Uasin Gishu', 'Elgeyo Marakwet', 'Nandi',
  'Baringo', 'Laikipia', 'Nakuru', 'Narok', 'Kajiado', 'Kericho', 'Bomet',
  'Kakamega', 'Vihiga', 'Bungoma', 'Busia', 'Siaya', 'Kisumu', 'Homa Bay',
  'Migori', 'Kisii', 'Nyamira', 'Nairobi',
] as const;

export type County = typeof KENYA_COUNTIES[number];

/**
 * The same list, most-populated first.
 *
 * Nairobi at the bottom of a 47-row select is correct by the Constitution and
 * wrong for the person using it: it is where most of the listings are and most
 * of the scrolling would be. Used where somebody is choosing where THEY are
 * rather than reading a schedule.
 */
const MOST_USED: County[] = [
  'Nairobi', 'Kiambu', 'Nakuru', 'Mombasa', 'Kisumu', 'Machakos', 'Kajiado',
  'Uasin Gishu',
];
export const COUNTIES_BY_USE: County[] = [
  ...MOST_USED,
  ...KENYA_COUNTIES.filter(c => !MOST_USED.includes(c)),
];
